import React, { useMemo } from 'react';
import ISO3166 from '../ISO3166-1.alpha2.json';
import { Wrapper, StyledSelect, ErrorText, Label } from './styles';

interface Country {
  code: string;
  label: string;
}

interface Meta {
  touched: boolean;
  dirty: boolean;
  error?: string[];
}

interface Input {
  value: string;
  onChange: (value: string | undefined) => void;
  onBlur: (value: string) => void;
}

interface SelectCountriesProps {
  input: Input;
  meta: Meta;
  label?: string;
  no_options: string;
  placeholder?: string;
  [key: string]: any;
}

const SelectCountries: React.FC<SelectCountriesProps> = ({
  input,
  meta,
  label,
  no_options,
  placeholder = '',
  ...rest
}) => {
  const countriesArray: Country[] = useMemo(() => {
    return Object.entries(ISO3166).map(([code, label]) => ({
      code,
      label,
    }));
  }, []);

  const hasInteraction = meta.touched || meta.dirty;
  const showError = hasInteraction && Boolean(meta.error && meta.error.length);
  const showValid = hasInteraction && input?.value?.length === 2;

  const noOptionsMessage = ({ inputValue }: { inputValue: string }) => {
    if (inputValue.trim()) {
      return no_options.replace(`{value}`, inputValue);
    }
    return placeholder;
  };

  return (
    <>
      <Wrapper $error={showError} $valide={showValid}>
        {label && <Label>{label}</Label>}
        <StyledSelect
          isClearable={true}
          isSearchable={true}
          getOptionLabel={({ label }) => label}
          getOptionValue={({ code }) => code}
          name="countries"
          options={countriesArray}
          placeholder={placeholder}
          value={countriesArray.find((el) => el.code === input.value)}
          onChange={(e) => input.onChange(e?.code)}
          onBlur={() => input.onBlur(input.value)}
          noOptionsMessage={noOptionsMessage}
          {...rest}
        />
        {showError &&
          meta.error.map((error) => <ErrorText key={error}>{error}</ErrorText>)}
      </Wrapper>
    </>
  );
};

export { SelectCountries };
